(function($) {
    $(function() {

        /**
         * Field Huge
         */
        $('.field-huge input[type=text]').keyup(function() {
            var isDirty = $(this).val().length > 0;

            if(isDirty) {
                $(this).addClass('is-dirty');
            } else {
                $(this).removeClass('is-dirty');
            }
        });

        /**
         * Reverse select
         */
        var $reverseSelect = $('.reverse-select');

        $reverseSelect.on('click', '.reverse-select__trigger', function() {
            $(this).closest('.reverse-select').toggleClass('is-extended');
        });

        $(document).click(function(e) {
            if (!$(e.target).is('.reverse-select__trigger, .reverse-select__trigger *, .reverse-select__panel')) {
                $('.reverse-select').removeClass('is-extended');
            }
        })

        $reverseSelect.on('change', 'input[type="radio"]', function() {
            var variant = parseInt($(this).val()),
                label = $(this).closest('label').find('li').text();

                // console.log($(this).closest('label').find('li').text());

            $(this).closest('.reverse-select__panel').siblings('.reverse-select__trigger').find('span').html(label);
            $(this).closest('.reverse-select').addClass('is-active');
            $('.customize-add-btn').removeClass('button-offset');
        });

        /**
         * Tooltip
         */
        var $tooltip = $('.tooltip');

        $tooltip.on('click', '.tooltip__trigger[data-action=click]', function(e) {
            e.preventDefault();
            $(this).closest('.tooltip').toggleClass('is-active');
            $(this).toggleClass('is-active');
        });
    });
})(jQuery);